<template>
  <div>
    <Header/>
    <Navigationzj/>
    <div class="new_detail w1200" v-loading="qyloading" style="padding-top: 10px">
      <div class="main-body">
        <div class="container" ref="wrap">
            <div class="row">
                <div class="main-page">
                    <div class="content-main">
                        <div class="row">
                            <div>
                                <div class="box bottom-main">
                                    <div class="info float-container">
                                        <div class="logo-title">
                                            <img src="../../assets/images/zpj_09.png">
                                            <h3>www.nmzp.com</h3>
                                        </div>
                                        <div class="right-title">
                                            <h3 class="text-uppercase">报价单</h3>
                                            <h4 class="text-uppercase">Quotation</h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div>
                                <div class="box">
                                    <div class="main-menu-link-shop" style="margin-left: 0;">
                                        <div class="main-menu-link-text">采购方：{{ quotation.name }}</div>
                                        <div>
                                            <span>
                                              联系人：{{ quotation.legal_person }}
                                            </span>
                                        </div>
                                        <div>
                                            <span>
                                                电话：{{ quotation.phone }}
                                            </span>
                                        </div>
                                        <div>
                                            <span>
                                                地址：{{ quotation.address }}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="main-menu-link-shop">
                                        <div class="main-menu-link-text">销售方：志鹏供应链（内蒙古）有限公司</div>
                                        <div>
                                            <span>
                                              联系人：{{ quotation.cname }}
                                            </span>
                                        </div>
                                        <div>
                                            <span>
                                              电话：{{ quotation.cphone }}
                                            </span>
                                        </div>
                                        <div>
                                            <span>
                                              地址：内蒙古自治区呼和浩特市赛罕区锡林南路与地质局南街交汇处未名楼A段1层1-0
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div>
                                <div class="box">
                                    <div class="info float-containers">
                                        <div class="bottom-title">
                                            <h3 class="text-uppercase">表单编号</h3>
                                            <h4 class="text-uppercase">{{ quotation.formnumber }}</h4>
                                        </div>
                                        <div class="bottom-title">
                                            <h3 class="text-uppercase">客户编号</h3>
                                            <h4 class="text-uppercase">{{ quotation.cusnumber }}</h4>
                                        </div>
                                        <div class="bottom-title">
                                            <h3 class="text-uppercase">销售顾问</h3>
                                            <h4 class="text-uppercase">{{ quotation.salescons }}</h4>
                                        </div>
                                        <div class="bottom-title">
                                            <h3 class="text-uppercase">报价日期</h3>
                                            <h4 class="text-uppercase">{{ quotation.addtime }}</h4>
                                        </div>
                                        <div class="bottom-title" style="border-right: 2px solid #5178b5;">
                                            <h3 class="text-uppercase">有效期至</h3>
                                            <h4 class="text-uppercase">{{ quotation.endtime }}</h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div>
                                <div class="banner-main-home">
                                    <div class="banner-main-home-text">
                                        <el-table
                                          ref="singleTable"
                                          :data="goodsMessage"
                                          border
                                          stripe
                                          fit
                                          style="width: 100%;"
                                          :header-cell-style="{textAlign:'center',color: '#333333'}"
                                          :cell-style="{textAlign:'center'}"
                                        >
                                          <el-table-column
                                            type="selection"
                                            width="40"
                                          >
                                          </el-table-column>
                                          <el-table-column
                                            prop="order_num"
                                            label="序号"
                                            width="50"
                                          >
                                          </el-table-column>
                                          <el-table-column
                                            label="名称"
                                          >
                                            <template slot-scope="scope">
                                              <el-popover v-if="scope.row.imgpath" trigger="hover" placement="top">
                                                <el-image
                                                  style="width: 150px; height: 150px"
                                                  :src="scope.row.imgpath"
                                                  :preview-src-list="scope.row.srcList">
                                                </el-image>
                                                <div slot="reference" class="name-wrapper">
                                                  {{ scope.row.title }}
                                                </div>
                                              </el-popover>
                                              <div v-else slot="reference" class="name-wrapper">
                                                {{ scope.row.title }}
                                              </div>
                                            </template>
                                          </el-table-column>
                                          <el-table-column
                                            prop="model_number"
                                            label="型号"
                                          >
                                          </el-table-column>
                                          <el-table-column
                                            prop="number"
                                            label="数量"
                                            width="50"
                                          >
                                          </el-table-column>
                                          <el-table-column
                                            prop="units"
                                            label="单位"
                                            width="50"
                                          >
                                          </el-table-column>
                                          <el-table-column
                                            prop="brand"
                                            label="品牌"
                                            width="100"
                                          >
                                          </el-table-column>
                                          <el-table-column
                                            label="货期"
                                            width="50"
                                          >7日
                                          </el-table-column>
                                          <el-table-column
                                            prop="tax_price"
                                            label="含税单价"
                                            width="100"
                                          >
                                          </el-table-column>
                                          <el-table-column
                                            prop="total_price"
                                            label="含税总价"
                                            width="100"
                                          >
                                          </el-table-column>
                                          <el-table-column
                                            prop="remarks"
                                            label="备注"
                                            width="120"
                                          >
                                          </el-table-column>
                                        </el-table>
                                        <div class="banner-main-bottom-text">
                                            <span class="banner-main-left-text">金额合计</span>
                                            <span class="banner-main-right-text">¥ {{ quotation.total }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 gz">
                                <div class="box london">
                                    <div class="info float-container">
                                        <div class="col-sm-12 london-title">
                                            <h3 class="text-uppercase">单位盖章</h3>
                                            <h4 class="text-uppercase">志鹏供应链（内蒙古）有限公司</h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="col-md-6" style="width: 200px;margin-top: 30px;margin-left: 250px">
                                <div class="box paris">
                                    <div class="info float-container">
                                        <div class="col-sm-12 paris-title">
                                            <h3 class="text-uppercase">负责人签字</h3>
                                        </div>
                                        <div class="qm"></div>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                        <div class="row">
                            <div>
                                <div class="box paris">
                                    <div class="info float-container">
                                        <div class="col-sm-12 london-titles paris-title">
                                            <h3 class="text-uppercase title-jz">客户需求：</h3>
                                            <div class="text-uppercase-title">{{ quotation.demand }}</div>
                                            <!-- <h3 class="text-uppercase">
                                                <div class="text-uppercase-padding">
                                                    <span class="title-jz">收款方式：</span>微信支付
                                                </div>
                                                <div class="text-uppercase-padding wangyou">
                                                    <span class="title-jz">收款账号：</span>0602005209200006532
                                                </div>
                                            </h3> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
      <!-- <el-button type="primary" icon="el-icon-document" class="daochubjd" @click="print()">导出报价单</el-button> -->
      <el-button type="primary" icon="el-icon-tickets" class="daochubjd" @click="dialogOrderVisible = true">转为订单</el-button>
      <el-button type="primary" icon="el-icon-document" class="daochubjd" @click="doexcel()" style="float: right">导出报价单</el-button>
    </div>
    <el-dialog title="报价转订单" :visible.sync="dialogOrderVisible" width="40%">
      <el-form :model="formData" :rules="ruless" ref="FormOrder" label-width="100px" class="demo-ruleForm">
        <el-row>
          <el-col>
            <el-form-item label="工厂名称" prop="factory_code">
              <el-cascader v-model="formData.factory_code" :options="companyList" clearable filterable :props="{ value: 'id',label: 'name'}"  style="width: 90%;" placeholder="请选择工厂" size="small"></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogOrderVisible = false">取 消</el-button>
        <el-button type="primary" @click="changeBusOrder()">确 定</el-button>
      </span>
    </el-dialog>
    <Footer/>
  </div>
</template>
<script>

import api from '@/api/quotation'
import expense from '@/api/expense'
import Header from '@/components/Resources/Header'
import Footer from '@/components/Footer'
import Navigationzj from '@/components/Navigationzj'
import html2canvas from 'html2canvas'
import JsPDF from 'jspdf'

export default {
  name: 'Faster',
  components: {
    Header,
    Navigationzj,
    Footer
  },
  inject: ['reload'], // 注入依赖
  data () {
    return {
      quotation: {},
      goodsMessage: [],
      qyloading: false,
      dialogOrderVisible: false,
      formData: {
        factory_code: ''
      },
      ruless: {
        factory_code: [{ required: true, message: '请选择工厂', trigger: 'blur' }]
      },
      companyList: [],
      primary_key: 'id'
    }
  },
  watch: {
    $route (to, from) {
      this.reload()
    }
  },
  mounted () {
    this.getQuotation()
    this.getCompanyList()
  },
  methods: {
    getQuotation () {
      this.qyloading = true
      api.getQuotation({id: this.$route.query.id}).then(res => {
        this.quotation = res.items
        this.goodsMessage = res.items.goodsMessage
        this.qyloading = false
      })
    },
    print () {
      // 当下载pdf时，若不在页面顶部会造成PDF样式不对,所以先回到页面顶部再下载
      let top = this.$refs.wrap
      // console.log(top)
      if (top != null) {
        top.scrollIntoView()
        top = null
      }
      html2canvas(this.$refs.wrap, {
        allowTaint: true
      }).then(function (canvas) {
        const contentWidth = canvas.width
        const contentHeight = canvas.height
        // 一页pdf显示html页面生成的canvas高度;
        let pageHeight = (contentWidth / 592.28) * 841.89
        // 未生成pdf的html页面高度
        let leftHeight = contentHeight
        // 页面偏移
        let position = 0
        // a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
        let imgWidth = 595.28
        let imgHeight = (592.28 / contentWidth) * contentHeight
        let pageData = canvas.toDataURL('image/jpeg', 1.0)
        const PDF = new JsPDF('', 'pt', 'a4')
        // 有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
        // 当内容未超过pdf一页显示的范围，无需分页
        if (leftHeight < pageHeight) {
          PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
        } else {
          while (leftHeight > 0) {
            PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
            leftHeight -= pageHeight
            position -= 841.89
            // 避免添加空白页
            if (leftHeight > 0) {
              PDF.addPage()
            }
          }
        }

        // const pageData = canvas.toDataURL("image/jpeg", 1.0);
        // //p表示纵向，l表示横向，px是单位 ,[宽，长]->[x,y]
        // const PDF = new JsPdf("p", "px", [2550, 3100]);
        // PDF.addImage(pageData, "JPEG", 0, 0, 2550, 3100);
        PDF.save('导出报价单.pdf')
      })
    },
    doexcel () {
      api.doExcel({quotation: this.quotation}).then(res => {
        if (res.code === 20000) {
          window.open(res.savename)
        } else {
          this.$message.error('导出错误')
        }
      })
    },
    getCompanyList () {
      expense.getCompanyList().then(response => {
        this.companyList = response.message
      })
    },
    changeBusOrder () {
      if (this.$refs.singleTable.selection.length > 0) {
        var ids = this.$refs.singleTable.selection.map(a => a[this.primary_key])
        this.$refs['FormOrder'].validate((valid) => {
          if (valid) {
            var Data = {
              formData: this.formData,
              quotation: this.quotation,
              ids: ids
            }
            api.changeBusOrder(Data).then((response) => {
              if (response.code === 20000) {
                this.$notify({
                  title: '成功',
                  message: response.message,
                  type: 'success'
                })
                this.dialogOrderVisible = false
                this.formData.factory_code = ''
              }
            })
          }
        })
      } else {
        this.$message({ message: '请选择要转为订单的数据', type: 'error' })
      }
    }
  }
}
</script>
<style scoped>
.container {
  width: 100%;
  border: 1px solid #EBEEF5;
  margin-right: auto;
  margin-left: auto;
}
.row {
  width: 100%;
  height: auto;
}
.main-page {
  position: relative;
}
.box {
  display: block;
}
.bottom-main {
  width: 100%;
  border-top: 7px solid #436aa6;
}
.info {
  width: 100%;
  padding: 15px 0 0;
}
.logo-title {
  width: 82%;
  float: left;
  padding-left: 15px;
  margin-top: -10px;
}
.logo-title h3{
  padding-left: 40px;
  margin-top: -5px;
  margin-bottom: 10px;
  color: #436aa6;
  font-weight: bold;
}
.box img {
  width: 20%;
}
.right-title {
  width: 15%;
  float: left;
}
.right-title h3 {
  font-size: 30px;
  margin: 15px 0;
}
.text-uppercase {
  text-transform: uppercase;
}
.main-menu-link-shop {
  background-color: #f2f2f2;
  width: 46%;
  height: 130px;
  float: left;
  margin-left: 96px;
  margin-bottom: 10px;
  font-size: 14px;
}
.main-menu-link-shop > div {
  padding: 5px 5px 0px 10px;
}
.main-menu-link-text {
  font-size: 18px;
  text-align: left;
  font-weight: bold;
}
.bottom-title {
  width: 19%;
  height: 50px;
  float: left;
  padding: 0 0 0 9.5px;
  border-left: 2px solid #5178b5;
  margin: 0px 0px 10px;
}
.bottom-title h3 {
  text-align: center;
  color: #5178b5;
  font-size: 16px;
  margin: 0px 5px;
}
.bottom-title h4 {
  text-align: center;
  font-size: 16px;
  margin: 0px 5px;
}
.float-containers {
  /* margin-left: 30px; */
}
.banner-main-home {
  padding: 5px 0 5px 0;
}
.banner-main-home-text {
  width: 100%;
  color: #000;
  text-shadow: none;
}
.banner-main-bottom-text {
  border-top: 7px solid #436aa6;
  font-weight: bold;
  font-size: 20px;
}
.banner-main-left-text {
  line-height: 40px;
  padding-left: 120px;
}
.banner-main-right-text {
  line-height: 40px;
  float: right;
  padding-right: 120px;
}
.gz {
  background-image: url(../../assets/images/bjzyz.png);
  background-repeat: no-repeat;
  background-size: 34%;
  background-position: center;
}
.col-md-6 {
  width: 30%;
  float: left;
  position: relative;
  min-height: 1px;
  padding-left: 110px;
}
.london-title {
  padding: 0 0 0 5px;
  margin: 80px 0px;
}
.london-title h3 {
  font-size: 18px;
  margin-left: 5px;
}
.london-title h4 {
  font-size: 14px;
  margin: 5px;
}
.paris-title{
  padding: 0 0 0 5px;
  margin-top: 20px;
}
.paris-title h3 {
  font-size: 18px;
  margin-left: 5px;
}
.qm {
  width: 170px;
  height: 60px;
  background-image: url(../../assets/images/qm.png);
  background-repeat: no-repeat;
  background-size: 45%;
  background-position: bottom left;
  border-bottom: 1px solid #000;
  margin-left: 10px;
}
.london-titles {
  padding: 0 0 0 5px;
}
.london-titles h3 {
  font-size: 18px;
  margin-left: 114px;
  padding-top: 200px;
}
.title-jz {
  font-weight: bold;
}
.text-uppercase-title {
  width: 75%;
  border-bottom: 1px solid #000;
  margin-left: 114px;
  padding-top: 10px;
}
.text-uppercase-padding {
  float: left;
  padding-bottom: 20px;
}
.wangyou {
  margin-left: 210px;
}
.paris {
  padding-bottom: 35px;
}
.daochubjd {
  width: 49%;
  height: 55px;
  background: #436aa6;
  border-radius: 5px;
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/view/enquiry/quotationsd.vue